import "./Blogs.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Common_Blog_Card from "../common_components/common_blog_card/Common_Blog_Card";
import Common_Back_Header from "../common_components/common_back_btn/Common_Back_Btn";
import Pagination_Holder from "../pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import { getblog } from "../../features/blog/Slice";

const Blogs = () => {
  const navigate = useNavigate();
  // const [currentPage, setCurrentPage] = useState(1);

  const blogsPerPage = 12;

   const [currentPage, setCurrentPage] = useState(1);
// const totalPages = Math.ceil(blogData.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const paginatedData = blogData.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//    const itemsPerPage = 5;

  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`, { state: blog });
  };

  const blogData = [
    {
      id: 1,
      image: "/assets/images/blog/blog_img1.png",
      title: "AC, Cooler or Fan? How Your Mattress Affects Summer Sleep",
      date: "2 hrs ago",
    },
    {
      id: 2,
      image: "/assets/images/blog/blog_img2.png",
      title: "Mattress weight vs durability: Is heavier always better?",
      date: "1 day ago",
    },
    {
      id: 3,
      image: "/assets/images/blog/blog_img3.png",
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      date: "25/01/2026",
    },
    {
      id: 4,
      image: "/assets/images/blog/blog_img3.png",
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      date: "2 hrs ago",
    },
    {
      id: 5,
      image: "/assets/images/blog/blog_img1.png",
      title: "AC, Cooler or Fan? How Your Mattress Affects Summer Sleep",
      date: "1 day ago",
    },
    {
      id: 6,
      image: "/assets/images/blog/blog_img2.png",
      title: "Mattress weight vs durability: Is heavier always better?",
      date: "25/01/2026",
    },
    {
      id: 7,
      image: "/assets/images/blog/blog_img3.png",
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      date: "2 hrs ago",
    },
    {
      id: 8,
      image: "/assets/images/blog/blog_img2.png",
      title: "Mattress weight vs durability: Is heavier always better?",
      date: "1 day ago",
    },
    {
      id: 9,
      image: "/assets/images/blog/blog_img1.png",
      title: "AC, Cooler or Fan? How Your Mattress Affects Summer Sleep",
      date: "25/01/2026",
    },
    {
      id: 10,
      image: "/assets/images/blog/blog_img1.png",
      title: "AC, Cooler or Fan? How Your Mattress Affects Summer Sleep",
      date: "2 hrs ago",
    },
    {
      id: 11,
      image: "/assets/images/blog/blog_img2.png",
      title: "AC, Cooler or Fan? How Your Mattress Affects Summer Sleep",
      date: "1 day ago",
    },
    {
      id: 12,
      image: "/assets/images/blog/blog_img2.png",
      title: "Mattress weight vs durability: Is heavier always better?",
      date: "25/01/2026",
    },
    {
      id: 13,
      image: "/assets/images/blog/blog_img3.png",
      title: "Kids’ Mattresses: Safety, Firmness & What Parents Should Know",
      date: "2 hrs ago",
    },
    {
      id: 14,
      image: "/assets/images/blog/blog_img2.png",
      title: "Mattress weight vs durability: Is heavier always better?",
      date: "1 day ago",
    },
  ];

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogData.slice(indexOfFirstBlog, indexOfLastBlog);

  const blog = useSelector((state) => state.blog.blog);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblog());
  }, [dispatch]);

  const itemsPerPage = 8;
  const totalPages = Math.ceil(blog?.data?.length / itemsPerPage);

  const handlePageChange = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setCurrentPage(pageNum);
    }
  };

  const paginatedData = blog?.data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <section className="Blogs About_Banner">
      <div className="container">
        <div className="About_Banner_holder">
          <Common_Back_Header />
        </div>

        <div className="container">
          <div className="blog_cards_section">
            <div className="row">
              {paginatedData &&
                paginatedData.map((blog, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
                    <Common_Blog_Card
                      key={blog.id}
                      blog={blog}
                      handleBlogClick={handleBlogClick}
                    />
                  </div>
                ))}
            </div>

            <div className="pagination_div">
              <Pagination_Holder
                onPageChange={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
